import React from 'react';
import axios from 'axios';
import $ from "jquery"
import{ useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Swiper, SwiperSlide } from "swiper/react";

import "swiper/css";
import "swiper/css/effect-fade";
import "swiper/css/navigation";
import "swiper/css/pagination";


import { Autoplay ,EffectFade, Navigation, Pagination } from "swiper";
import { MoonLoader } from 'react-spinners';
import { getTrendingMovies } from '../../Redux/tmSlice';
import { useDispatch, useSelector } from 'react-redux';




function Movies(props) {
  
    
    const [popMovies, getPopMovies] = useState(null);

    const {data} = useSelector(state => state.trendingMovies)

   


    
    const dispatch = useDispatch()
  
   
    async function getRatedMovies() {
      let { data } = await axios.get("https://api.themoviedb.org/3/movie/top_rated?api_key=0ada3fcaa2e394ff1ad6ed7e6c5db6c5&language=en-US&page=1");
      getPopMovies(data.results);
    }
    
  
    useEffect(() => {
      getRatedMovies();
      dispatch(getTrendingMovies())
     
    }, [])
    
    
    
    return <>
    



      {data && popMovies? <><div className='container my-5'>
        <div className="row">
          <Swiper
        spaceBetween={30}
        effect={"fade"}
        navigation={false}
        loop={true}
        autoplay={{
          delay: 2500,
          disableOnInteraction: false,
        }}
        pagination={{
          dynamicBullets: true,
        }}
        modules={[Autoplay,EffectFade, Navigation, Pagination]}
        className="mySwiper"
      >
        {data.results.map((movies, idx) => <SwiperSlide  key={idx}>
          <div className='text-center'>
          <img className='w-75 position-relative rounded-3 overflow-hidden' src={"https://image.tmdb.org/t/p/original/" + movies.backdrop_path} />
          <div className='position-absolute layer d-flex justify-content-center align-items-center'>
            <div>
            <h2>{movies.title}</h2>
            </div>
          </div>
          </div>
        </SwiperSlide>)}
      </Swiper>

        </div>
    </div>
     <div className="container">
      <div className="row">
        <div className="col-md-4 align-self-center">
          <div>
            <div className='upper'></div>
            <h5>Trending Movies to watch now</h5>
            <p className='text-muted'>Lorem ipsum, dolor sit amet consectetur adipisicing elit. Illo fuga quibusdam expedita quos non id optio nisi excepturi nostrum iusto maxime necessitatibus soluta suscipit, exercitationem laborum accusantium commodi, reiciendis iste.</p>
            <div className='lower'></div>
          </div>
        </div>
        {data.results.map((movie, idx) => <div key={idx} className='col-md-2 my-2'>
        <Link to={`/moviedetails/${movie.id}`}>
          <div className="movie imghov position-relative">
            <img className='rounded-3 w-100' src={"https://image.tmdb.org/t/p/w500/" + movie.poster_path} alt="moviepic" />
            <h6 className='rating p-2 rounded-circle'>{(movie.vote_average).toFixed(1)}</h6>
            <h6 className='mt-2'>{movie.title}</h6>
          </div>
          </Link>
        </div>)}
      </div>
    </div>
    <div className="container">
      <div className="row">
        <div className="col-md-4 align-self-center">
          <Link to={"/topratedmovies"}>
          <div className="trending">
            <div className='upper'></div>
            <h5>Top Rated Movies to watch now</h5>
            <p className='text-muted'>Lorem ipsum, dolor sit amet consectetur adipisicing elit. Illo fuga quibusdam expedita quos non id optio nisi excepturi nostrum iusto maxime necessitatibus soluta suscipit, exercitationem laborum accusantium commodi, reiciendis iste.</p>
            <div className='lower'></div>
          </div>
          </Link>
        </div>
        {popMovies.map((movie, idx) => <div key={idx} className='col-md-2 my-2'>
        <Link to={`/moviedetails/${movie.id}`}>
          <div className="movie imghov position-relative">
            <img className='rounded-3 w-100' src={"https://image.tmdb.org/t/p/w500/" + movie.poster_path} alt="moviepic" />
            <h6 className='rating p-2 rounded-circle'>{(movie.vote_average).toFixed(1)}</h6>
            <h6 className='mt-2'>{movie.title}</h6>
          </div>
          </Link>
        </div>)}
      </div>
    </div> </>: <div className='vh-100 d-flex justify-content-center align-items-center'>
    <MoonLoader color="white"/>
    </div>}
    


</>
}

export default Movies;